import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { motion } from 'framer-motion';
import './MobileMenu.css';
import LanguageSwitcher from '../UI/LanguageSwitcher/LanguageSwitcher';
import MyLottie from '../MyLottie/MyLottie';
import { useTranslation } from 'react-i18next';

const menuLinks = [
  { path: '/', display: 'home' },
  { path: '/about', display: 'about' },
  { path: '/services', display: 'services' },
  { path: '/cases', display: 'cases' },
];

const MobileMenu = ({ menuOpen, toggleMenu, to }) => {
  const [activeLanguage, setActiveLanguage] = useState('en');
  const { t } = useTranslation();
  return (
    <>
      {menuOpen && (
        <motion.div
          className="mobile-menu"
          initial={{ y: '-100%' }}
          animate={{ y: 0 }}
          exit={{ y: '-100%' }}
        >
          <ul className="mobile-menu-links">
            {menuLinks.map((link, index) => (
              <motion.li
                key={index}
                className="mobile-menu__item"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{
                  delay: index * 0.3,
                  duration: 0.7,
                  ease: 'easeOut',
                }}
              >
                <NavLink
                  to={link.path}
                  className="mobile-menu__link"
                  onClick={toggleMenu}
                >
                  {t(link.display)}
                </NavLink>
              </motion.li>
            ))}
            <MyLottie className="mobile-anima" />
          </ul>

          <ul className="mobile-social__row">
            <h5 className="mobile-social__subtitle"> {t('keepInTouch')}</h5>
            <div className="mobile-social__wrapper">
              <li>
                <a
                  href="https://wa.me/380956584268"
                  target="_blank"
                  rel="noopener"
                  className="mobile-social__link"
                  aria-label="WhatsApp"
                >
                  <svg
                    width="24"
                    height="24"
                    fill="#00AEEF"
                    viewBox="0 0 24 24"
                  >
                    <path d="M12 2C6.48 2 2 6.48 2 12A9.96 9.96 0 0 0 3.56 17.33L2 22L6.67 20.44A9.96 9.96 0 0 0 12 22C17.52 22 22 17.52 22 12S17.52 2 12 2ZM17 14.09C16.18 14.09 15.37 13.95 14.61 13.68C14.24 13.56 13.81 13.67 13.55 13.94L12.46 15.03C10.32 14.03 9.07 12.78 8.06 10.64L9.15 9.55C9.41 9.29 9.52 8.86 9.4 8.49A10.75 10.75 0 0 1 9 6.11C9 5.5 8.5 5 7.89 5H6C5.45 5 5 5.45 5 6C5 11.52 9.48 16 15 16C15.55 16 16 15.55 16 15V13.11C16 12.5 15.5 12 14.89 12Z" />
                  </svg>
                </a>
              </li>

              <li>
                <a
                  href="https://www.instagram.com/serendix_company/"
                  target="_blank"
                  rel="noopener"
                  className="mobile-social__link"
                  aria-label="Instagram"
                >
                  <svg
                    width="24"
                    height="24"
                    fill="#00AEEF"
                    viewBox="0 0 24 24"
                  >
                    <path d="M7.75 2h8.5A5.75 5.75 0 0 1 22 7.75v8.5A5.75 5.75 0 0 1 16.25 22h-8.5A5.75 5.75 0 0 1 2 16.25v-8.5A5.75 5.75 0 0 1 7.75 2Zm0 1.5A4.25 4.25 0 0 0 3.5 7.75v8.5A4.25 4.25 0 0 0 7.75 20.5h8.5A4.25 4.25 0 0 0 20.5 16.25v-8.5A4.25 4.25 0 0 0 16.25 3.5h-8.5Zm4.25 3.25a5.25 5.25 0 1 1 0 10.5a5.25 5.25 0 0 1 0-10.5Zm0 1.5a3.75 3.75 0 1 0 0 7.5a3.75 3.75 0 0 0 0-7.5Zm5.25-.75a.75.75 0 1 1 0 1.5a.75.75 0 0 1 0-1.5Z" />
                  </svg>
                </a>
              </li>

              <li>
                <a
                  href="https://twitter.com/"
                  target="_blank"
                  rel="noopener"
                  className="mobile-social__link"
                  aria-label="Twitter"
                >
                  <svg
                    width="24"
                    height="24"
                    fill="#00AEEF"
                    viewBox="0 0 24 24"
                  >
                    <path d="M23 3A10.9 10.9 0 0 1 19.54 4.84A4.48 4.48 0 0 0 12 9.75V10A10.66 10.66 0 0 1 3 4A4.48 4.48 0 0 0 5.47 13.78A4.52 4.52 0 0 1 2 12.88V13A4.48 4.48 0 0 0 6.68 17.29A4.48 4.48 0 0 1 2 18.92A9 9 0 0 0 14 21A12.94 12.94 0 0 1 3 23.47A18 18 0 0 0 10 25C21 25 23 15.5 23 9V8.5A10.27 10.27 0 0 0 24 5.5A10.9 10.9 0 0 1 23 3Z" />
                  </svg>
                </a>
              </li>

              <li>
                <a
                  href="https://www.linkedin.com/in/serendix-company-598099363/"
                  target="_blank"
                  rel="noopener"
                  className="mobile-social__link"
                  aria-label="LinkedIn"
                >
                  <svg
                    width="34"
                    height="34"
                    fill="#00AEEF"
                    viewBox="0 0 24 24"
                  >
                    <path d="M4.98 3.5A1.5 1.5 0 1 1 8 3.5A1.5 1.5 0 0 1 4.98 3.5ZM4 6H8V18H4V6ZM10 6H14V8.17C14.59 7.3 15.56 6.67 16.75 6.67C19.1 6.67 20 8.32 20 10.56V18H16V11.22C16 9.86 15.46 9.17 14.52 9.17C13.37 9.17 13 10.05 13 11.21V18H10V6Z" />
                  </svg>
                </a>
              </li>
            </div>
          </ul>
          <motion.a
            href="https://wa.me/+380956584268"
            target="_blank"
            rel="noopener noreferrer"
            className="mobile-btn__write"
            animate={{
              scale: [1, 1.1, 1],
              opacity: [1, 0.8, 1],
            }}
            transition={{
              duration: 1.5,
              repeat: Infinity,
              repeatType: 'loop',
            }}
          >
            Write
          </motion.a>
        </motion.div>
      )}
    </>
  );
};

export default MobileMenu;
